<template>
	<div>
		<Map
			ref="mapRef"
			:center="(selectedMarker && selectedMarker.geo) || liheGeo"
			:zoom="zoom"
			:options="options"
		>
		<template v-if="mainMarker">
			<GMapMarker
				:position="mainMarker.geo"
				:clickable="true"
				:icon="mainMarkerIcon"
				@click="
					() => {
						handleMarkerClick(mainMarker.liheId);
					}
				"
			></GMapMarker>
		</template>
	
			<template v-if="markersArray">
				<GMapMarker
					v-for="(marker, marker_i) in markersArray"
					:key="marker_i"
					:position="marker.geo"
					:icon="{ url: nearbyIconURL }"
					:clickable="true"
					@click="
						() => {
							handleMarkerClick(marker.liheId);
						}
					"
				></GMapMarker>
			</template>
	
			<GMapInfoWindow
				v-if="selectedMarker"
				ref="mapPopup"
				:options="infoOptions"
				:position="selectedMarker.geo"
				:opened="state.infoWinOpen"
				@closeclick="() => setPopupOpen(false)"
			>
				<div class="d-flex dlex-row nowrap text-start" style="max-width: 320px">
					<!-- <div class="plus-info-close cursor-pointer d-flex align-items-center justify-content-center bg-light-gray rounded-circle">
				<svg data-v-02ba4707="" width="6" height="6" class="icon"><use data-v-02ba4707="" xlink:href="#___icon___close-x"></use></svg>
			  </div> -->
					<b-button
						class="tf-close-mapPopup float-right cursor-pointer rounded-circle"
						@click="() => setPopupOpen(false)"
					>
						<!-- <ClsBtn :classes="'ts-x-sm'" /> -->
					</b-button>
					<div class="map-popup-img-wrapper col-4 p-0 d-flex flex-column nowrap">
						<img
							class="map-popup-img w-100 img-fluid h-100"
							:src="selectedMarker.picture"
							alt=""
						/>
					</div>
					<div
						class="col-8 pe-0 ps-2 d-flex flex-column nowrap justify-content-between"
					>
						<div class="text-start">
							<div class="me-2 body-strong text-grey-900">
								{{ selectedMarker.liheName }}
							</div>
							<svg
								width="15"
								height="15"
								viewBox="0 0 15 15"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M7.59829 0.75C4.64487 0.75 2.25 3.14487 2.25 6.09829C2.25 7.5633 2.83834 8.89 3.79267 9.85604C4.7619 10.838 6.18967 12.6924 7.59829 14.25C8.99947 12.6924 10.473 10.821 11.4454 9.81348C12.3742 8.8517 12.9466 7.54202 12.9466 6.09829C12.9466 3.14487 10.5517 0.75 7.59829 0.75ZM7.59829 7.57394C6.62375 7.57394 5.83433 6.78452 5.83433 5.80997C5.83433 4.83543 6.62375 4.046 7.59829 4.046C8.57284 4.046 9.36226 4.83543 9.36226 5.80997C9.36226 6.78452 8.57284 7.57394 7.59829 7.57394V7.57394Z"
									fill="currentColor"
								/>
							</svg>
	
							<span class="ml-1 link-default">{{ selectedMarker.station }}</span>
						</div>
						<div class="">
							<div class="d-flex flex-row nowrap justify-content-start mt-2">
								<div class="mb-2">
									<div
										class="d-flex flex-row nowrap align-items-center justify-content-end"
									>
										<div class="subcaption text-grey-900 me-1 text-nowrap">
											{{ content.map_insteadOf }}
										</div>
										<div
											v-if="crossedPrice"
											class="subcaption text-grey-900 me-1 text-gray"
										>
											<del class="prestation-crossed-price">{{
												displayPrice(crossedPrice * 100, locale)
											}}</del>
										</div>
										<div
											v-if="pricePerLogement"
											class="prestation-price heading text-grey-900"
										>
											{{ displayPrice(pricePerLogement * 100, locale) }}
										</div>
									</div>
									<div
										class="caption text-grey-900 d-flex justify-content-start align-items-center"
									>
										<span
											v-if="pricePerPerson"
											class="prestation-price-per-person"
										>
											{{ content.map_thatIs }}
											{{ displayPrice(pricePerPerson * 100, locale) }}/{{
												content.planner_resumePerPerson
											}}
										</span>
										<div
											v-if="maxPromo"
											class="d-flex align-items-center justify-content-center rounded bg-green me-1"
										>
											<div
												class="prestation-discount caption text-grey-900 text-white px-1"
											>
												-{{ maxPromo }}%
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							v-if="
								selectedMarker &&
								mainMarker &&
								selectedMarker.liheId != mainMarker.liheId
							"
						>
							<a
								class="text-light-blue font-weight-600 font-14"
								:href="selectedMarker.productPageUrl + season"
								target="_blank"
								>Voir la résidence</a
							>
						</div>
					</div>
				</div>
			</GMapInfoWindow>
		</Map>
	</div>
</template>

<script>
import iconUrl from "@/vue/map/geo.svg";
import nearbyIconURL from "@/vue/map/nearby.svg";
import Marker from "@/vue/map/marker";
import localeConfig from "@/config/localeConfig";
import displayPrice from "@/displayPrice/displayPrice";
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	getPrestPerPrice,
	getPrestMaxPromo,
} from "@/logic/pricesAndDiscount";
import ClsBtn from "@/vue/common/clsBtnV2";
import { Map,
  GMapMarker,
  GMapInfoWindow
} from '@fawmi/vue-google-maps'

export default {
	name: "MapMain",
	components: {

		Map, 
		GMapMarker, 
		GMapInfoWindow
	},
	data() {
		return {
			isMapOpen: false,
			planningState: null,
			iconUrl: iconUrl,
			nearbyIconURL,
			data: {
				updatedVariant: null,
				nearby: null,
			},
			state: {
				selectedLiheId: window.lihe.id,
				infoWinOpen: true,
				loading: false,
			},
			options: {
				mapId: "326e7548c437d85e",
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: true,
				disableDefaultUI: true,
			},
			zoom: 17,
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -45,
				},
			},
			
		};
	},
	computed: {
		content() {
			return window.content;
		},

		locale() {
			const language = document.querySelector("html").getAttribute("lang");
			return localeConfig[language];
		},

		season() {
			let season = "#season=H";
			if (window.seasonManager.season == "E") {
				season = "#season=E";
			}
			return season;
		},

		mainLiheId() {
			return window.lihe.id;
		},

		mainMarkerIcon() {
			// Get the computed CSS color value for --blue-700
			const blue700Color = getComputedStyle(document.documentElement)
				.getPropertyValue('--blue-700').trim() || '#517ACB';
			
			// Create SVG with the blue-700 color
			const svg = `
				<svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M31.913 3.1499C19.5086 3.1499 9.4502 13.2084 9.4502 25.6127C9.4502 31.7658 11.9212 37.3379 15.9294 41.3953C20.0002 45.5196 25.9968 53.3081 31.913 59.8499C37.798 53.3081 43.9867 45.4481 48.0709 41.2165C51.9718 37.1771 54.3759 31.6764 54.3759 25.6127C54.3759 13.2084 44.3174 3.1499 31.913 3.1499ZM31.913 31.8105C27.8199 31.8105 24.5044 28.4949 24.5044 24.4018C24.5044 20.3087 27.8199 16.9931 31.913 16.9931C36.0061 16.9931 39.3217 20.3087 39.3217 24.4018C39.3217 28.4949 36.0061 31.8105 31.913 31.8105Z" fill="${blue700Color}" />
				</svg>
			`;
			return {
				url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
				scaledSize: { width: 63, height: 63 }
			};
		},

		liheGeo() {
			const [mainLat, mainLon] = window.lihe.geolocalisation.split(",");
			return { lat: Number(mainLat), lng: Number(mainLon) };
		},

		mainMarker() {
			const lihe = window.lihe;
			const updatedVariant = this.data.updatedVariant;

			if (!updatedVariant) return null;

			return new Marker({
				geo: this.liheGeo,
				picture: lihe.prestations[0].picturesAccomodation[0].img,
				station: lihe.prestations[0].station,
				liheName: lihe.prestations[0].liheName,
				maxPromo: updatedVariant.maxPromo,
				pricePerLogement: updatedVariant.pricePerLogement,
				pricePerPerson: updatedVariant.pricePerPerson,
				crossedPrice: updatedVariant.crossedPrice,
				liheId: lihe.id,
				productPageUrl: null,
			});
		},

		markersArray() {
			if (!this.data.nearby) return null;

			return this.data.nearby
				.map((nearbyPrest) => {
					if (nearbyPrest.liheId == window.lihe.id) return null;
					return new Marker({
						geo: {
							lat: Number(nearbyPrest.geo.lat),
							lng: Number(nearbyPrest.geo.lon),
						},
						picture: nearbyPrest.image,
						station: nearbyPrest.stationName,
						liheName: nearbyPrest.liheName,
						maxPromo: nearbyPrest.promo,
						pricePerLogement: nearbyPrest.pricePerLogement,
						pricePerPerson: nearbyPrest.pricePerPerson,
						crossedPrice: nearbyPrest.crossedPrice * nearbyPrest.maxCapacity,
						liheId: nearbyPrest.liheId,
						productPageUrl: nearbyPrest.productPageUrl,
					});
				})
				.filter((_) => _);
		},

		markersObj() {
			if (!this.markersArray) return null;
			const markersObj = {};
			this.markersArray.forEach((marker) => {
				markersObj[marker.liheId] = marker;
			});

			return markersObj;
		},

		selectedMarker() {
			if (!this.markersObj || !this.mainMarker) return null;

			if (this.mainMarker.liheId === this.state.selectedLiheId) {
				return this.mainMarker;
			}
			return this.markersObj[this.state.selectedLiheId];
		},

		crossedPrice() {
			const isHaveQuoteResponse = !!this.planningState.prices;
			return getPrestCrossedPrice(this.selectedMarker, isHaveQuoteResponse);
		},
		pricePerPerson() {
			return getPrestPerPrice(
				this.selectedMarker,
				this.planningState.participants.length
			);
		},
		pricePerLogement() {
			return getPrestTotalPrice(this.selectedMarker);
		},
		maxPromo() {
			return getPrestMaxPromo(this.selectedMarker);
		},
	},
	methods: {
		displayPrice,
		toggleFullScreen() {
			const mapElement = document.querySelector(".vue-map > div");
			if(!mapElement) {
				console.error("no map element")
				return
			}

			if (!document.fullscreenElement) {
				if (mapElement.requestFullscreen) {
				mapElement.requestFullscreen();
				} else if (mapElement.mozRequestFullScreen) { /* Firefox */
				mapElement.mozRequestFullScreen();
				} else if (mapElement.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
				mapElement.webkitRequestFullscreen();
				} else if (mapElement.msRequestFullscreen) { /* IE/Edge */
				mapElement.msRequestFullscreen();
				}
			} else {
				if (document.exitFullscreen) {
				document.exitFullscreen();
				} else if (document.mozCancelFullScreen) { /* Firefox */
				document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) { /* Chrome, Safari & Opera */
				document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) { /* IE/Edge */
				document.msExitFullscreen();
				}
			}

		},
		async planningStateRefreshFunc() {
			if (
				!global.planningState ||
				!global.planningState.cheapestPrestation ||
				!global.planningState.selectedDates["BeginDate"] ||
				!global.planningState.selectedDates["EndDate"]
			)
				return;

				this.planningState = global.planningState;

			if (!this.data.nearby) {
				await this.loadLiheNearBy();
			}

			let storeItems = global.planningState.cheapestPrestation.variants;
			let cheapestVariant = storeItems.reduce(function (res, obj) {
				return obj.pricePerPerson < res.pricePerPerson ? obj : res;
			});
			this.data.updatedVariant=cheapestVariant;
		},

		setUpdatePriceListener() {
			global.addEventListener(
				"planningStateRefreshed",
				this.planningStateRefreshFunc
			);
		},

		setPopupOpen(bool) {
			this.state.infoWinOpen=bool;
		},
		setLiheIdSelected(liheId) {
			this.state.selectedLiheId=liheId;
		},
		togglePopupOpen() {
			this.state.infoWinOpen=!this.state.infoWinOpen;
		},

		toggleInfoWindow(liheId) {
			this.state.selectedLiheId=liheId;
			this.state.infoWinOpen=!this.state.infoWinOpen;
		},

		handleMarkerClick(liheId) {
			if (liheId === this.selectedMarker.liheId) {
				this.togglePopupOpen();
			} else {
				this.setLiheIdSelected(liheId);
				this.setPopupOpen(true);
			}
		},

		async loadLiheNearBy() {
			if (this.state.loading) return;

			this.state.loading=true;

			const [mainLat, mainLon] = window.lihe.geolocalisation.split(",");
			const [beginDay, beginMonth, beginYear] =
				window.planningState.selectedDates["BeginDate"].split("/");
			const [endDay, endMonth, endYear] =
				window.planningState.selectedDates["EndDate"].split("/");
			const beginDate = `${beginYear}-${beginMonth}-${beginDay}`;
			const endDate = `${endYear}-${endMonth}-${endDay}`;
			const payload = {
				criteria: [],
				season: window.seasonManager.season,
				capacity: [
					"2",
					"3",
					"4",
					"5",
					"6",
					"7",
					"8",
					"9",
					"10",
					"11",
					"12",
					"13",
					"14",
					"15",
					"16",
					"17",
					"18",
					"19",
					"20",
				],
				beginDate: beginDate,
				endDate: endDate,
				nearbyLat: mainLat,
				nearbyLon: mainLon,
				nearbyDist: "3",
				liheIds: [window.lihe.id],
			};

			const res = await window.searchEngineService.getLiheNearbyData(
				{ locale: this.locale },
				payload
			);

			this.data.nearby=res;
			this.state.loading=false;

		},
		openMap() {
      		this.isMapOpen = true;
      		// also re-trigger any resize if needed
      		window.dispatchEvent(new Event('resize'));
    	},
	},
	async mounted() {
		this.setUpdatePriceListener();
		this.planningStateRefreshFunc();
		this.$refs.mapRef.$mapPromise.then((map) => {
			this.toggleFullScreen()
			window.addEventListener("openMapClick", this.toggleFullScreen)

			const mapElement = document.querySelector(".vue-map > div");
			// Create a new button element
			const button = document.createElement("button");
			button.className = "ts-x-black ts-x-lg map-close-button"; 
			mapElement.appendChild(button);
			button.addEventListener("click", this.toggleFullScreen)
		})
		document.addEventListener('fullscreenchange', () => {
			// When we drop out of FS, close the map overlay again:
			if (!document.fullscreenElement) {
				this.isMapOpen = false;
			}
		});


	},
};
</script>

<style>
.map-popup-img {
	object-fit: cover;
	max-width: 100px;
	width: 100px;
	min-height: 100px;
	min-width: 100px;
	border-radius: 7px;
}
.map-popup-img-wrapper {
	border-radius: 7px;
	overflow: hidden;
}
.leaflet-touch .leaflet-bar a {
	width: 44px;
	height: 36px;
	background: rgba(13, 20, 27, 0.6);
	color: white;
}
.leaflet-touch .leaflet-bar a:first-child {
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}
.leaflet-touch .leaflet-bar a:last-child {
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
}

.gm-style .gm-style-iw-t::after {
	display: none !important;
}
.tf-close-mapPopup {
	z-index: 9;
	display: block;
	position: absolute;
	top: 2px;
	right: 1px;
}

/* .gmnoprint div[draggable="false"] {
	border-radius: var(--border-radius-secondary);
} */
.gmnoprint div[draggable="false"] {
	border-radius: var(--border-radius-card) !important;
}

button[aria-label="Toggle fullscreen view"] {
	border-radius: var(--border-radius-card) !important;
}
</style>
